/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState, useCallback, useRef } from "react";
import { api } from "../../lib/api";
import { useApp } from "../../contexts/AppContext";
import { Button } from "../ui/button";
import { Volume2, Square, CheckCircle2 } from "lucide-react";

/** Rappel vocal lingala J-1 (RDC) : audio ElevenLabs si généré, sinon voix du navigateur sur le texte lingala. */
export function PatientRappelCard({ patientId }) {
  const { has } = useApp();
  const [items, setItems] = useState([]);
  const [playing, setPlaying] = useState(null);
  const audioRef = useRef(null);
  const load = useCallback(() => api.get(`/telesoin/rappels?patient_id=${patientId}`).then(({ data }) => setItems(data)).catch(() => null), [patientId]);
  useEffect(() => { load(); }, [load]);
  if (!has("rappel_vocal") || items.length === 0) return null;
  const stop = () => { audioRef.current?.pause(); window.speechSynthesis?.cancel(); setPlaying(null); };
  const play = async (r) => {
    stop();
    setPlaying(r.id);
    const done = async () => { setPlaying(null); await api.post(`/telesoin/rappels/${r.id}/ecoute`).catch(() => null); load(); };
    if (r.voix === "elevenlabs") {
      try {
        const res = await api.get(`/telesoin/rappels/${r.id}/audio`, { responseType: "blob" });
        const a = new Audio(URL.createObjectURL(res.data)); audioRef.current = a; a.onended = done; await a.play(); return;
      } catch { /* repli navigateur */ }
    }
    if (window.speechSynthesis) {
      const u = new SpeechSynthesisUtterance(r.texte_ln); u.lang = "ln"; u.rate = 0.9; u.onend = done; window.speechSynthesis.speak(u);
    } else { done(); }
  };
  return (
    <div data-testid="patient-rappel-card" className="bg-[#D4AF5A] rounded-3xl p-5 text-[#0A1426] flex flex-col gap-3">
      <div className="flex items-center gap-2"><Volume2 size={18} /><span className="text-[11px] uppercase tracking-wider font-bold">Rappel vocal · Lingala</span></div>
      {items.map((r) => (
        <div key={r.id} data-testid={`rappel-${r.id}`} className="bg-white/80 rounded-2xl p-3 flex flex-col gap-2">
          <p data-testid={`rappel-texte-ln-${r.id}`} className="font-[Fraunces] text-[15px] font-bold leading-snug">{r.texte_ln}</p>
          <p className="text-[12px] text-[#0A1426]/70">{r.texte_fr}</p>
          <div className="flex items-center gap-2">
            {playing === r.id
              ? <Button data-testid={`rappel-stop-${r.id}`} onClick={stop} className="h-11 rounded-full bg-[#0A1426] text-white font-bold px-4"><Square size={14} className="mr-2" /> Arrêter</Button>
              : <Button data-testid={`rappel-ecouter-${r.id}`} onClick={() => play(r)} className="h-11 rounded-full bg-[#0A1426] text-white font-bold px-4"><Volume2 size={16} className="mr-2" /> Écouter le rappel</Button>}
            {r.ecoute_le && <span className="text-[11px] font-bold inline-flex items-center gap-1 text-[#2d7a2d]"><CheckCircle2 size={13} /> Écouté</span>}
            <span className="text-[10px] text-[#0A1426]/60 ml-auto">{r.voix === "elevenlabs" ? "Voix Mélodie" : "Voix du téléphone"}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
